export const isCrossOriginIsolated = (): boolean => window.crossOriginIsolated;
